import React from 'react';
import SectionHeading from '../Typography/SectionHeading/SectionHeading';
import EditButton from '../Typography/EditButton/EditButton';
import { contactInfoLine1, contactInfoLine2 } from './util';
import styles from './style.css';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const ReviewContactInformation = ({ customer, handleClick }) => (
  <div className="review-customer-information">
    <div className="section-header">
      <SectionHeading text="My Contact Information">
        <EditButton onClick={handleClick('contact')} currentlyEditing={false} />
      </SectionHeading>
    </div>
    <div className="customer-information-lines">
      <div
        data-name={generateGeneralTestID(
          'Review',
          'AccountOwnerContactInformationLine1'
        )}>
        {contactInfoLine1(customer)}
      </div>
      <div
        data-name={generateGeneralTestID(
          'Review',
          'AccountOwnerContactInformationLine2'
        )}>
        {contactInfoLine2(customer)}
      </div>
    </div>
    <style jsx>{styles}</style>
  </div>
);

export default ReviewContactInformation;
